// Modules with bespoke cleanup logic in their own logout-related mutation, so they don't
// need (and shouldn't get) a warning for missing a generic "resetState".
const MODULES_WITH_CUSTOM_LOGOUT_CLEANUP = ["auth/"];

// Dev-only guard: throws when a namespaced module holds state but has no "resetState"
// mutation, so leftover user data can't silently survive logout unnoticed.
function warnIfModuleHoldsUnresetState(moduleName, rawModule) {
  if (!import.meta.env.DEV || MODULES_WITH_CUSTOM_LOGOUT_CLEANUP.includes(moduleName)) {
    return;
  }

  const state = typeof rawModule.state === "function" ? rawModule.state() : rawModule.state;
  const hasState = !!state && Object.keys(state).length > 0;

  if (hasState) {
    throw new Error(
      `[resetStoreAfterLogout] Module "${moduleName}" holds state but has no "resetState" mutation - it will not be cleared on logout.`,
    );
  }
}

export function resetStoreAfterLogout(store) {
  store.subscribeAction({
    after: (action) => {
      if (action.type !== "auth/logout") {
        return;
      }

      // hasUnsavedChanges lives on the root store, not in a namespaced module, so the loop
      // below can't reach it - clear it explicitly to avoid it blocking navigation in the
      // next session.
      store.commit("setHasUnsavedChanges", false);

      const modules = Object.keys(store._modulesNamespaceMap);

      modules.forEach((moduleName) => {
        const module = store._modulesNamespaceMap[moduleName];
        if (!module || !module._rawModule) return;

        const moduleMutations = module._rawModule.mutations || {};
        const hasResetMutation = Object.prototype.hasOwnProperty.call(
          moduleMutations,
          "resetState",
        );

        if (hasResetMutation) {
          store.commit(`${moduleName}resetState`);

          return;
        }

        warnIfModuleHoldsUnresetState(moduleName, module._rawModule);
      });
    },
  });
}
